import React from 'react'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import classnames from 'classnames'
import densityLayers from 'densityLayers.js'

const HeatMapOptions = ({ t, uiStore }) => {
  const handleInputChange = (e) => {
    uiStore.densityLayer = e.target.value
    uiStore.hideHeatmapSettings()
  }

  return (
    <div className='heatmap-options'>
      <ul className='heatmap-options__list'>
        <li className='heatmap-options__item'>
          <input onChange={handleInputChange} value='none' className='heatmap-options__input' id='none' type='radio' name='density' />
          <label className={classnames({ 'heatmap-options__label': true, active: uiStore.densityLayer === 'none' })} htmlFor='none'>{t('GLOBAL.NONE')}</label>
        </li>
        {
          densityLayers.layers.map(layer => {
            const { id: value, name: label } = layer
            return (
              <li className='heatmap-options__item' key={value}>
                <input onChange={handleInputChange} value={value} className='heatmap-options__input' id={value} type='radio' name='density' />
                <label className={classnames({ 'heatmap-options__label': true, active: uiStore.densityLayer === value })} htmlFor={value}>{label}</label>
              </li>
            )
          })
        }
      </ul>
    </div>
  )
}

export default withTranslation()(inject('uiStore')(observer(HeatMapOptions)))
